import * as Yup from "yup"; // Import Yup
import { validatePasswordPolicy } from "../../lib/utils/validatePasswordPolicy";

// {
//   password,
//   confirmPassword
// }

const createPasswordValidationSchema = (passwordPolicy) => Yup.object().shape({
    nickname: Yup.string().required("Nickname is required"),
    password: Yup.string()
      .required("Password is required")
      .test(
        "password-policy",
        "Invalid Password",
        function (value) {
          const errorMessage = validatePasswordPolicy({password: value, passwordPolicy: passwordPolicy});
          return errorMessage ? this.createError({ message: errorMessage }) : true;
        }
      ),
    confirmPassword: Yup.string()
      .required("Password is required")
      .oneOf([Yup.ref("password")], "Passwords must match!")
});

export default createPasswordValidationSchema;
